import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from "@/views/Main.vue"
import api from "@/api.js";
import store from "@/store/index.js"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    meta: {
      auth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("@/views/Login.vue")
  },
  {
    path: '/history',
    name: 'history',
    meta: {
      auth: true,
    },
    component: () => import("@/views/History.vue")
  },
  {
    path: '/templates',
    name: 'templates',
    meta: {
      auth: true,
    },
    component: () => import("@/views/Templates.vue")
  },
  {
    path: '/finance',
    name: 'finance',
    meta: {
      auth: true,
    },
    component: () => import("@/views/Finance.vue")
  },
  {
    path: '/lists',
    name: 'lists',
    meta: {
      auth: true,
    },
    component: () => import("@/views/Lists.vue")
  },
  {
    path: '/scheduler',
    name: 'scheduler',
    meta: {
      auth: true,
    },
    component: () => import("@/views/Scheduler.vue")
  },
  {
    path: '/task/:id',
    name: 'task-scheduler',
    meta: {
      auth: true,
    },
    component: () => import("@/views/Task.vue")
  },
  {
    path: '/taskf/:id',
    name: 'task-finance',
    meta: {
      auth: true,
    },
    component: () => import("@/views/Task.vue")
  },
  {
    path: '/taskh/:id',
    name: 'task-history',
    meta: {
      auth: true,
    },
    component: () => import("@/views/Task.vue")
  },
  {
    path: '/admin',
    name: 'admin',
    meta: {
      auth: true,
    },
    component: () => import("@/views/Admin.vue")
  },
  {
    path: '/list/:id',
    name: 'list',
    meta: {
      auth: true,
    },
    component: () => import("@/views/List.vue")
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(function (to, from, next) {
  if (to.meta.auth) {
    if (store.state.user.userData == null) {
      api.ping().then(response => {
        if (!response.user || !response.user.idx) {
          next('/login');
        } else {
          next();
        }
      }).catch(() => {
        next('/login');
      });
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router
